// Frame limiter choices per environment. Every mode paces on requestAnimationFrame (game/loop.ts).
// A browser runs rAF at the display's refresh rate, so there the uncapped choice is VSync. The
// desktop app (desktop/) starts WebView2 with vsync and the frame-rate limit off, so there rAF runs
// as fast as the GPU allows and the uncapped choice is Unlimited.

import { FRAME_LIMITERS } from "./schema";
import type { FrameLimiter } from "./schema";

/** The desktop app adds `GunrunDesktop/<version>` to its user agent. */
export function isDesktopShell(userAgent: string = navigator.userAgent): boolean {
  return userAgent.includes("GunrunDesktop/");
}

/** Most frames per second the limiter renders, or null for every animation frame. */
export function frameCap(limiter: FrameLimiter): number | null {
  return limiter === "vsync" || limiter === "unlimited" ? null : Number(limiter);
}

export interface LimiterOption {
  value: FrameLimiter;
  label: string;
}

/** The uncapped choice first, then the caps. */
export function limiterOptions(desktop: boolean): LimiterOption[] {
  const uncapped: LimiterOption = desktop ? { value: "unlimited", label: "Unlimited" } : { value: "vsync", label: "VSync" };
  const caps = FRAME_LIMITERS.filter((l) => frameCap(l) !== null).map((value) => ({ value, label: `${value} FPS` }));
  return [uncapped, ...caps];
}

/** The option a stored limiter shows as: "vsync" and "unlimited" are the same uncapped choice. */
export function shownLimiter(limiter: FrameLimiter, desktop: boolean): FrameLimiter {
  if (frameCap(limiter) !== null) return limiter;
  return desktop ? "unlimited" : "vsync";
}
